export default __webpack_public_path__ + "1d228cd2d765cc6012f1ddbdf86e8cff.png";